import { Box, Divider, Skeleton } from "@chakra-ui/react";
import { useQueryParams } from "@madkom/query-params";
import { useHistory } from "react-router-dom";

import { useGetFriendlyUrl } from "utils/hooks/useGetFriendlyUrl";

import { ExpiredAppointmentActionButtons } from "../ExpiredAppointmentsTable/ExpiredAppointmentActionButtons";
import { AppointmentMobileRow } from "../../components/AppointmentMobileRow";
import { useGetPaginatedUserAppointments } from "../../../../infrastructure/useGetPaginatedUserAppointments";

interface IProps {
  limit: number;
}

const ExpiredAppointmentsMobileRows = ({ limit }: IProps) => {
  const { push } = useHistory();
  const { friendlyUrl } = useGetFriendlyUrl();
  const { params } = useQueryParams<{ offset: number }>();
  const { data: appointments, isFetched } = useGetPaginatedUserAppointments(
    {
      limit: limit,
      offset: params.offset,
      expired: true,
    },
    {
      suspense: false,
    }
  );

  if (!appointments || !isFetched) {
    return (
      <>
        {Array.from(Array(limit).keys()).map((key) => {
          return (
            <Box my={2} key={key}>
              <Skeleton h="80px" isLoaded={false} />
              <Divider mt={2} />
            </Box>
          );
        })}
      </>
    );
  }

  return (
    <>
      {appointments.userAppointments.map((appointment) => {
        return (
          <AppointmentMobileRow
            onClick={() =>
              push(
                `/e-rezerwacja/${friendlyUrl}/uzytkownik/historyczne-wizyty/${appointment.appointmentId}`
              )
            }
            appointment={appointment}
            actionButtons={
              <ExpiredAppointmentActionButtons appointment={appointment} />
            }
          />
        );
      })}
    </>
  );
};

export { ExpiredAppointmentsMobileRows };
